<template>
  <div class="text-center">
    <div class="timer-container">
      <div class="timer">
        <div class="timer-number">{{TimerText}}</div>
        <svg class="timer-svg">
          <circle
            :style="{
              strokeDashoffset: progressCircle + 'px'
            }"
            ref="circle"
            r="250"
            cx="300"
            cy="300"></circle>
        </svg>
      </div>
    </div>

    <div class="mt-4">
      <el-button size="small" @click="start">start</el-button>
      <el-button size="small" @click="pause">pause</el-button>
      <el-button size="small" @click="resume">resume</el-button>
      <el-button size="small" @click="finish">finish</el-button>
      <el-button size="small" @click="add(1)">add 1min</el-button>
      <el-button size="small" @click="add(5)">add 5min</el-button>
      <el-button size="small" @click="add(-5)">sub 5min</el-button>
    </div>
  </div>
</template>

<script>
import { Howl } from "howler";
import beep from "@/assets/sounds/beep.mp3";
// import util from '@/util'

export default {
  components: {
  },
  props: {
    timerDuration: {
      type: Number,
      default: 90
    },
    startWithMount: {
      type: Boolean,
      default: true
    },
    intervalMilliseconds: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      item: {
        name: 'Achim', //this.name= this.$auth.currentUser.photoURL;
        img: 'https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=126' // this.image=this.$auth.currentUser.photoUR;
      },
      timerId: null,
      timeAtStart: 0,
      progressCircle: 0,
      TimerText: 0,
      pauseElapsedTime: 0,
      isPaused: false
    };
  },
  mounted() {
    if (this.startWithMount) {
      this.start();
    }
  },
  beforeDestroy() {
    clearInterval(this.timerId);
    this.$emit("timer-destroyed");
  },
  methods: {
    start() {
      this.timeAtStart = performance.now();
      this.timerId = setInterval(this.update, this.intervalMilliseconds);
      this.isPaused = false;
    },
    pause() {
      this.pauseElapsedTime = this.elapsedTimeInSec();
      clearInterval(this.timerId);
      this.isPaused = true;
      this.TimerText = "PAUSED";
    },
    resume() {
      this.timeAtStart = performance.now() - this.pauseElapsedTime * 1000;
      this.timerId = setInterval(this.update, this.intervalMilliseconds);
      this.isPaused = false;
    },
    add(amount) {
      /* causes warning, but it's ok since we don't reload the component */
      this.timerDuration = this.timerDuration + amount * 60;
    },
    finish() {
      clearInterval(this.timerId);
      this.TimerText = "ENDE";
      this.progressCircle = 0;
      this.$emit("Timer-finished");
      this.play_sound();
    },
    elapsedTimeInSec() {
      /* Zeit in Sekunden seit timer start */
      return (performance.now() - this.timeAtStart) / 1000.0;
    },
    update() {
      if (this.elapsedTimeInSec() > this.timerDuration) {
        this.finish();
        return;
      }

      let progress = Math.round(
        (this.elapsedTimeInSec() / this.timerDuration) * 1200
      );
      let numeric = Math.round(this.timerDuration - this.elapsedTimeInSec());

      this.progressCircle = progress;
      this.TimerText = this.showHoursMinutesSeconds(numeric);
    },
    // onSoundDone() {
    //   console.log("sound done...");
    // },
    play_sound() {
      // let vm = this;
      let sound = new Howl({
        src: [beep],
        // src: "assets/sounds/beep.mp3", "assets/beep.webm", "assets/beep.wav",
        autoplay: true,
        loop: false,
        volume: 0.75,
        // onend: vm.onSoundDone // Leads to endless loop
      });
      return sound;
    },
    showHoursMinutesSeconds(seconds) {
      // return util.showHoursMinutesSeconds(seconds);
      seconds = parseFloat(seconds);
      if (seconds) {
        let min = Math.floor(seconds / 60);
        let sec = seconds - min * 60;
        min = (min < 10 ? "0" : "") + min;
        sec = (sec < 10 ? "0" : "") + sec;
        return `${min}:${sec}`;
      } else {
        return seconds;
      }
    }
  }
};
</script>

<style>
.timer-container {
  margin: auto;
  margin-top: 10px;
  width: 600px;
}

.timer {
  position: relative;
  height: 600px;
  width: 600px;
  text-align: center;
}

.timer-number {
  color: black;
  display: inline-block;
  line-height: 600px;
  font-size: 48pt;
}

.timer svg {
  position: absolute;
  top: 0;
  right: 0;
  width: 600px;
  height: 600px;
  transform: rotateY(-180deg) rotateZ(-90deg);
}

.timer svg circle {
  stroke-dasharray: 1570px;
  stroke-dashoffset: 0;
  stroke-linecap: butt;
  stroke-width: 12px;
  stroke: black;
  fill: none;
  /*animation: Timer 10s linear once forwards;*/
}

.timer .avatar {
  position: absolute;
  top: 250px;
  left: 145px;
  z-index: 1000;
  width: 100px;
  height: 100px;
}

@keyframes noTimer {
  from {
    stroke-dashoffset: 0;
  }
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes Timer {
  from {
    stroke-dashoffset: 0;
  }
  to {
    stroke-dashoffset: 1570px; /* 2 * PI * r */
  }
}
</style>
